import { FC, SVGProps } from 'react'

const ArrowIconDown: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      data-testid="arrow-icon-down"
      {...props}
    >
      <path
        d="M4.25 1.651v9m0 0l-2.68-2.535m2.68 2.535 2.678-2.535"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default ArrowIconDown
